<template>
  <div class="update-org">
    <div class="container">
      <div class="update-org-header">
        編輯組別
      </div>
      <el-form
        ref="form"
        label-position="right"
        label-width="120px"
        :model="formData"
      >
        <el-form-item
          prop="departmentName"
          label="組別名稱："
          :rules="[
            { required: true, message: '組別名稱不能為空',trigger: 'blur'},
            { min: 1, max:60, message: '不超過30字符', trigger: 'blur' }
          ]"
        >
          <el-input
            v-model.trim="formData.departmentName"
            maxlength="60"
            show-word-limit
            class="basc_input"
            placeholder="請輸入組別名稱"
          />
        </el-form-item>
        <el-form-item
          prop="departmentManagerID"
          label="組別負責人："
        >
          <el-select
            v-model="formData.departmentManagerID"
            placeholder="請選擇組別負責人"
            no-data-text="無數據"
            class="basc_input"
          >
            <el-option
              v-if="managerOptions.length > 0"
              label="請選擇"
              :value="0"
            />
            <el-option
              v-for="item in managerOptions"
              :key="item.accountID"
              :label="`${item.name}-${item.email}`"
              :value="item.accountID"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          prop="storeId"
          label="關聯分行："
        >
          <el-select
            v-model="formData.storeId"
            no-data-text="無數據"
            no-match-text="無匹配數據"
            filterable
            placeholder="請選擇關聯分行"
            class="basc_input"
            popper-class="custom-option"
            @change="handleStoreChange"
          >
            <el-option
              label="請選擇"
              :value="0"
            />
            <el-option
              v-for="item in storeOptions"
              :key="item.storeID"
              :label="item.storeName"
              :value="item.storeID"
            >
              {{ item.storeName + '('+item.addressWithCulture+')' }}
              <!-- <el-tooltip class="item" effect="dark" :content="item.addressWithCulture" placement="top">
                            <div>{{ item.storeName + '('+item.addressWithCulture+')' }}</div>
                        </el-tooltip> -->
            </el-option>
            <el-option
              label="立即新增分行資料"
              :value="10010"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="false"
          label="狀態："
          prop="status"
        >
          <el-radio-group v-model="formData.status">
            <el-radio label="Normal">
              啟用
            </el-radio>
            <el-radio label="Disable">
              停用
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label-width="0px"
          class="btn"
        >
          <el-button
            size
            type="primary"
            @click="updateDepartment"
          >
            儲存
          </el-button>
          <el-button @click="$router.go(-1)">
            返回
          </el-button>
        </el-form-item>
      </el-form>
      <!-- HOUSEMIS-4135 -->
      <el-dialog
        title="新增分行"
        width="905px"
        :visible.sync="showBranch"
        :close-on-click-modal="false"
        @close="resetForm"
      >
        <el-form
          ref="yyForm"
          :model="yyForm"
          :rules="yyFormrules"
          label-width="180px"
          label-position="right"
        >
          <el-form-item
            label="分行名稱:"
            prop="storeName"
          >
            <el-input
              v-model="yyForm.storeName"
              class="basc_input padr_50"
              maxlength="40"
              show-word-limit
              placeholder="中文"
            />
            <span class="yy-tag">請輸入分行中文名稱，最多40字</span>
          </el-form-item>
          <el-form-item prop="storeNameEN">
            <el-input
              v-model="yyForm.storeNameEN"
              class="basc_input padr_50"
              maxlength="60"
              show-word-limit
              placeholder="英文"
            />
            <span class="yy-tag">請輸入分行英文名稱，最多60字</span>
          </el-form-item>
          <el-form-item label="分行標籤:">
            <el-input
              v-model="yyForm.label"
              class="basc_input"
              maxlength="20"
              placeholder=""
            />
            <span class="yy-tag">添加分行標籤後，方便在列表中搜尋</span>
          </el-form-item>
          <el-form-item
            label="分行電話:"
            prop="storeTelephone"
          >
            <el-input
              v-model="yyForm.storeTelephone"
              class="basc_input"
              maxlength="8"
            />
          </el-form-item>
          <el-form-item
            label="分行地址:"
            prop="address"
          >
            <el-input
              v-model="yyForm.address"
              class="basc_input padr_50"
              maxlength="100"
              show-word-limit
              placeholder="中文"
            />
          </el-form-item>
          <el-form-item prop="addressEN">
            <el-input
              v-model="yyForm.addressEN"
              class="basc_input padr_50"
              maxlength="300"
              show-word-limit
              placeholder="英文"
            />
          </el-form-item>
          <div class="txt_box">
            分行資料會在House730網站及App顯示，<br>
            同一個分行可以同時有多個組別的存在，組別的資料對分行沒有影響
          </div>
          <div class="yy-box-line" />
          <el-form-item class="yy-btns">
            <el-button @click="cancelForm">
              取消
            </el-button>
            <el-button @click="resetForm">
              重設
            </el-button>
            <el-button
              type="primary"
              @click="submitForm('yyForm')"
            >
              新增
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    name: 'Edit',
    data() {
        var checkPhone = (rule, value, callback) => {
            if (!/^\d+$/.test(value) || value[0] == 0 || value[0] == 1) {
                callback(new Error('請輸入合法的聯繫方式'));
            } else {
                callback();
            }
        };
        return {
            showBranch:false,
            yyForm: {
                isDepartment: false,
                storeName: '',
                storeNameEN: '',
                storeTelephone: '',
                address: '',
                addressEN: '',
                label: ''
            },
            yyFormrules: {
                storeName: [
                    {
                        required: true,
                        message: '請輸入分行名稱',
                        trigger: 'blur'
                    }
                ],
                storeNameEN: [
                    {
                        required: true,
                        message: '請輸入分行英文名稱',
                        trigger: ['blur', 'change']
                    }
                ],
                storeTelephone: [
                    {
                        required: true,
                        message: '請輸入分行聯繫方式',
                        trigger: 'blur'
                    },
                    {
                        validator: checkPhone,
                        trigger: 'blur'
                    }
                ],
                address: [
                    {
                        required: true,
                        message: '請輸入分行地址',
                        trigger: 'blur'
                    }
                ],
                addressEN: [
                    {
                        required: true,
                        message: '請輸入分行英文地址',
                        trigger: 'blur'
                    }
                ],
            },
            formData: {
                departmentName: '',
                departmentId: '',
                storeId: '',
                parentId: '',
                departmentManagerID: '',
                status: ''
            },
            managerOptions: [],
            storeOptions: []
        };
    },
    async created() {
        this.formData.departmentId = this.$route.params.id;
        await this.getDepartmentById(this.formData.departmentId);
        this.getDepManagerOptions();
        this.getStoreOptions();
    },
    methods: {
        cancelForm(){
            this.formData.storeId = '';
            this.yyForm.label = ''
            this.showBranch = false;
            this.resetForm()
        },
        resetForm(){
            this.formData.storeId = '';
            this.yyForm.label = ''
            this.$refs.yyForm.resetFields();
        },
        submitForm(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    // 新增分行
                    const add = await this.axios.post(this.pub.getApi().AddStore, {
                        companyID: this.userInfo.companyID,
                        storeName: this.yyForm.storeName,
                        storeNameEN: this.yyForm.storeNameEN,
                        storeTelephone: this.yyForm.storeTelephone,
                        address: this.yyForm.address,
                        addressEN: this.yyForm.addressEN,
                        label: this.yyForm.label,
                        isDepartment: this.yyForm.isDepartment
                    });
                    if (add.data.code == 0 && add.data.result) {
                        this.formData.storeId = '';
                        this.showBranch = false;
                        this.getStoreOptions('addDepart')
                        this.$message({
                            message: '添加分行成功',
                            type: 'success',
                            showClose: true
                        });
                    } else if (add.data.code == 400) {
                        this.$message({
                            message: '必填項不可為空',
                            type: 'error',
                            showClose: true
                        });
                    } else if (add.data.code == 2018) {
                        this.$message({
                            message: '組別已存在，添加分行失敗',
                            type: 'error',
                            showClose: true
                        });
                    } else {
                        this.$message({
                            message: '添加分行失敗',
                            error: 'error',
                            showClose: true
                        });
                    }
                    
                }
            });
        },
        handleStoreChange(val){
            this.showBranch = val === 10010 ? true :false
        },
        async getDepManagerOptions() {
            let res = await this.axios.post(this.pub.getApi().SearchCompanyUserInfo, {
                departmentID: this.formData.departmentId,
                pageIndex: 1,
                pageCount: 100
            });
            let { code, message, result } = res.data;
            // console.log(res);
            if (code === 0) {
                this.managerOptions = result.data;
            }
        },
        async getStoreOptions(type) {
            let res = await this.axios.get(this.pub.getApi().GetAllStoreByCompanyID, {
                params: {
                    companyID: this.userInfo.companyID
                }
            });
            // console.log(res);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.storeOptions = result;
                if(type == 'addDepart'){
                    this.formData.storeId = this.storeOptions[0].storeID;
                }
            }
        },
        // 通過id獲取組別信息
        async getDepartmentById(departmentID) {
            let res = await this.axios.get(this.pub.getApi().GetDepartmentById, {
                params: {
                    departmentID
                }
            });
            let { code, result, message } = res.data;
            // console.log(res);
            if (code === 0) {
                this.formData.departmentName = result.departmentName;
                this.formData.status = result.status;
                this.formData.departmentManagerID = result.departmentManagerID || '';
                this.formData.storeId = result.storeID || '';
                this.formData.parentId = result.parentID;
            }
        },
        // 更新組別
        updateDepartment() {
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    // console.log(11);
                    let res = await this.axios.post(this.pub.getApi().UpdateDepartment, {
                        departmentName: this.formData.departmentName,
                        departmentID: this.formData.departmentId,
                        storeID: this.formData.storeId || '',
                        departmentManagerID: this.formData.departmentManagerID || ''
                    });
                    // console.log(res);
                    let { code, result, message } = res.data;
                    if (code === 0) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            showClose: true
                        });
                        this.$router.go(-1);
                    } else if (code === 2018) {
                        this.$message({
                            message: '組別名稱已存在',
                            type: 'error',
                            showClose: true
                        });
                    } else {
                        this.$message({
                            message: '操作失敗',
                            type: 'error',
                            showClose: true
                        });
                    }
                } else {
                    return false;
                }
            });
        }
    },
    computed: {
        ...mapState(['userInfo'])
    }
    // watch: {
    //   $route(val) {
    //     console.log(this.$route);
    //   }
    // }
};
</script>
<style lang="less" scoped>
.custom-option .el-select-dropdown__item:last-child {
    color: #2C5CFA !important;
    font-weight: bold;
}
/deep/ .el-dialog {
    border-radius: 10px;

    .el-dialog__header {
        border-bottom: 1px solid #ccc;
    }
    .dialog-footer {
        .el-button {
            width: auto !important;
        }
    }
}
.update-org {
    text-align: left;
    padding-left: 20px;
    .basc_input{
        width: 450px;
    }
    .padr_50{
        /deep/.el-input__inner{
            padding-right: 53px;
        }
    }
    .txt_box{
        font-size: 14px;
        color: #171725;
        margin-left: 185px;
    }
    /deep/.el-form-item__label{
        color: #171725;
    }
    .yy-btns {
        padding: 20px;
        margin-bottom: 0px;
        .el-form-item__content {
            margin-left: 0px !important;
        }
        margin-left: 355px;
    }
    .yy-tag {
        font-size: 14px;
        color: #666;
        margin-left: 10px;
    }
    .container {
        background-color: #fff;
        width: 70%;
        border-radius: 20px;
        padding: 20px;
        .el-form {
            margin-top: 20px;
            .el-input {
                // width: 50%;
                // border-radius: 50%;
                /deep/.el-input__inner {
                    border-radius: 10px;
                    width: 450px;
                }
            }
            .el-select {
                // width: 50%;
                border-radius: 50%;
                /deep/.el-input__inner {
                    border-radius: 10px;
                }
            }
            .btn {
                border-top: 1px solid #f1f1f5;
                padding-top: 15px;
                text-align: left;
                .el-button {
                    width: 88px;
                    border-radius: 10px;
                    margin-left: 20px;
                }
            }
        }
    }
    .update-org-header {
        padding: 18px 0 24px;
        font-size: 24px;
        border-bottom: 1px solid #f1f1f5;
    }
}
</style>